import { Box, Button, TextField, Typography, DialogActions } from '@mui/material';
import { styled } from '@mui/material/styles';
import { getBusinessPalette } from './businessPalette';

// CustomButton styling for Old Customer Form
export const CustomButton = styled(Button, {
  shouldForwardProp: (prop) => prop !== 'businessId',
})(({ businessId }) => {
  const palette = getBusinessPalette(businessId);

  return {
    backgroundColor: palette.buttonBg,
    color: '#fff',
    padding: '8px 28px',
    fontSize: '18px',
    fontWeight: 'bold',
    borderRadius: '8px',
    boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.1)',
    textTransform: 'none',
    transition: 'background-color 0.3s ease, transform 0.2s ease',
    '&:hover': {
      backgroundColor: palette.buttonHoverBg,
      boxShadow: '0px 8px 16px rgba(0, 0, 0, 0.2)',
      transform: 'translateY(-2px)',
    },
    '&:disabled': {
      backgroundColor: '#CCCCCC',
      color: '#FFFFFF',
      boxShadow: 'none',
    },
  };
});

// FormContainer styling for Old Customer Form
export const FormContainer = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'businessId',
})(({ theme, businessId }) => {
  const palette = getBusinessPalette(businessId);

  return {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    backgroundColor: palette.formContainerBg,
    padding: '32px',
    borderRadius: '16px',
    boxShadow: '0px 6px 16px rgba(0, 0, 0, 0.1)',
    marginBottom: theme.spacing(5),
    marginTop: theme.spacing(3),
    maxWidth: '500px',
    margin: 'auto',
    border: `2px solid ${palette.formContainerBorder}`,
    [theme.breakpoints.down('sm')]: {
      marginBottom: theme.spacing(4),
      marginTop: theme.spacing(2),
    },
  };
});

// StyledTextField styling for Old Customer Form
export const StyledTextField = styled(TextField)({
  backgroundColor: '#FFFFFF',
  borderRadius: '8px',
  marginBottom: '16px',
  boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.1)',
  '& .MuiOutlinedInput-root': {
    '& fieldset': {
      border: 'none',
    },
  },
});

// Title styling for the Old Customer Form
export const FormTitle = styled(Typography, {
  shouldForwardProp: (prop) => prop !== 'businessId',
})(({ businessId }) => {
  const palette = getBusinessPalette(businessId);

  return {
    fontSize: '35px',
    fontWeight: 'bold',
    color: palette.formTitleColor,
    marginBottom: '24px',
    textAlign: 'center',
  };
});

// NewCustomerLink styling for the link to add a new customer
export const NewCustomerLink = styled(Typography, {
  shouldForwardProp: (prop) => prop !== 'businessId',
})(({ businessId }) => {
  const palette = getBusinessPalette(businessId);

  return {
    fontSize: '16px',
    color: 'black',
    textDecoration: 'underline',
    cursor: 'pointer',
    '&:hover': {
      color: palette.linkHoverColor,
    },
  };
});

// Custom styling for the Backdrop
export const StyledBackdrop = styled(Box)({
  zIndex: 9999,
  color: '#fff',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
});

// DialogContent Container
export const DialogContentContainer = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'businessId',
})(({ businessId }) => {
  const palette = getBusinessPalette(businessId);

  return {
    padding: '16px 24px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: palette.dialogContentBg,
    borderTop: `1px solid ${palette.dialogBorderColor}`,
  };
});

// BoldTypography styling
export const BoldTypography = styled(Typography)({
  fontWeight: 'bold',
});

// Styled DialogActions for the buttons
export const StyledDialogActions = styled(DialogActions)({
  padding: '8px 24px',
  display: 'flex',
  justifyContent: 'space-between',
});

// Cancel Button styling
export const CancelButton = styled(Button, {
  shouldForwardProp: (prop) => prop !== 'businessId',
})(({ businessId }) => {
  const palette = getBusinessPalette(businessId);

  return {
    textTransform: 'none',
    padding: '8px 24px',
    borderRadius: '8px',
    fontSize: '0.95rem',
    borderColor: palette.cancelButtonColor,
    color: palette.cancelButtonColor,
    flexGrow: 1,
    maxWidth: '100px',
    '&:hover': {
      backgroundColor: palette.cancelButtonHoverBg,
      borderColor: palette.cancelButtonColor,
    },
  };
});

// Proceed Button styling
export const ProceedButton = styled(Button, {
  shouldForwardProp: (prop) => prop !== 'businessId',
})(({ businessId }) => {
  const palette = getBusinessPalette(businessId);

  return {
    textTransform: 'none',
    padding: '8px 24px',
    borderRadius: '8px',
    fontSize: '0.95rem',
    backgroundColor: palette.proceedButtonBg,
    flexGrow: 1,
    maxWidth: '100px',
    '&:hover': {
      backgroundColor: palette.proceedButtonHoverBg,
    },
  };
});